import React from 'react';
import AddCTA from '../component/common/addcta';
import pic24 from '../assets/pic24.png'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import Header2 from '../component/common/title';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Cta from '../component/common/cta';
import pic30 from '../assets/pic30.png'
import Textarea from '../component/common/textarea';
import Selectinput from '../component/common/selectinput';
import pic31 from '../assets/pic31.png'
import './categories-content.css'
import pic44 from '../assets/pic44.png'
import './Exhibitors_management.css'
import Errormsginput from '../component/common/errormsginput';





const Exhibitorscontent = () => {

const [errors, setErrors] = useState({});
const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 6;


         const [Exhibitors, setExhibitors]= useState([]);

        useEffect(() => {
        const getExhibitors = async()=>{
            const res = await supabase.from('exhibitors').select(`
        *,
        exbition_event_exhibitors (
            event_exhibitors_id,
            exbition_event!exbition_event_exhibitors_event_exhibitors_id_fkey (
                event_name
            )
        )
    `)
    .order('id', { ascending: true });

        setExhibitors(res.data || []);
    };
    getExhibitors();
}, []);




const filteredExhibitors = Exhibitors
  .filter((item) =>
    item.exhibitor_name?.toLowerCase().includes(search.toLowerCase()))
 .filter((item) => {
    if (filter === "") return true;
    if (filter === "true") return item.status === true;
    if (filter === "false") return item.status === false;
    return true;
  })
.sort((a, b) => {
    if (sort === "booth_asc") return a.booth_number?.localeCompare(b.booth_number);
    if (sort === "booth_desc") return b.booth_number?.localeCompare(a.booth_number);
    return 0;
})
 


const totalPages = Math.ceil(filteredExhibitors.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const currentCategories = filteredExhibitors.slice(startIndex, endIndex);








const [links, setLinks] = useState([]);

useEffect(() => {
  const getLinks = async () => {
    const res = await supabase
      .from("exhibitor_categories")
      .select("*");

    setLinks(res.data || []);
  };

  getLinks();
}, []);




const getStatusLabel = (status) => {
  return status ? "Active" : "Inactive";
};

const getStatusClass = (status) => {
  return status ? "status-confirmed" : "status-cancelled";
};





// // this is my create function we el edit


const [editingId, setEditingId] = useState(null);

const [open, setOpen] = useState(false);




const [form, setForm] = useState({
  exhibitor_name: "",
  description: "",
  booth_number: "",
  contact_email: "",
     img_alt: "",
  image: "",
  hover_image: "",
  hover_alt: "",
    logo: "",  
   events: []
});




const [eventOptions, setEventOptions] = useState([]);



useEffect(() => {
       const getEvents = async () => {
    const { data } = await supabase.from("exbition_event").select("*");
    setEventOptions(data || []);};
       getEvents();}   , []);




const addEventSelect = () => {
  setForm((prev) => ({ ...prev, events: [...prev.events, ""] }));
};

const updateEvent = (value, index) => {
  const updated = [...form.events];
  updated[index] = value;
  setForm((prev) => ({ ...prev, events: updated }));
};

const removeEvent = (index) => {
  const updated = [...form.events];
  updated.splice(index, 1);
  setForm((prev) => ({ ...prev, events: updated }));
};



const handleSubmit = async (e) => {
  e.preventDefault();

  setErrors({});

  let hasError = false;
  const newErrors = {};

  if (!form.exhibitor_name) {
    newErrors.exhibitor_name = "Exhibitor name is required";
    hasError = true;
  }


  if (!form.events || form.events.length === 0) {
    newErrors.events = "At least one event is required";
    hasError = true;
  }

  setErrors(newErrors);
  if (hasError) return;



  let exhibitorId = editingId;

  if (editingId) {
    const { data, error } = await supabase
      .from("exhibitors")
      .update({
        exhibitor_name: form.exhibitor_name,
       description: form.description,
        booth_number: form.booth_number,
         contact_email: form.contact_email,
        img_alt: form.img_alt,
        image: form.image,
        hover_image: form.hover_image,
        logo: form.logo, 
        hover_alt: form.hover_alt,
      })
      .eq("id", editingId)
      .select()
      .single();

    if (error) return console.log(error.message);

      exhibitorId = data.id;

        await supabase.from("exbition_event_exhibitors").delete().eq("exhibitor_id", editingId);}else {
    const { data, error } = await supabase
      .from("exhibitors")
      .insert([{
        exhibitor_name: form.exhibitor_name,
        description: form.description,
        booth_number: form.booth_number,
        contact_email: form.contact_email,
          logo: form.logo, 
        img_alt: form.img_alt,
        image: form.image,
        hover_image: form.hover_image,
        hover_alt: form.hover_alt,
      }])
      .select()
      .single();

    if (error) return console.log(error.message);

     exhibitorId = data.id;
  }

 const eventsPayload = form.events
    .filter(Boolean)
    .map((event_id) => ({
      exhibitor_id: exhibitorId,
      event_exhibitors_id: event_id
    }));

 if (eventsPayload.length > 0) {
    await supabase.from("exbition_event_exhibitors").insert(eventsPayload);
  }



  setForm({
  exhibitor_name: "", description: "", booth_number: "",
  contact_email: "", img_alt: "", image: "",
  hover_image: "", hover_alt: "", events: []});
   setEditingId(null);
  setOpen(false);


  const { data } = await supabase.from('exhibitors').select(`*,exbition_event_exhibitors (
      event_exhibitors_id,exbition_event!exbition_event_exhibitors_event_exhibitors_id_fkey (event_name))
`).order('id', { ascending: true });

  setExhibitors(data || []);
};



// // this is my deleete function

const [showDeleteModal, setShowDeleteModal] = useState(false);
const [selectedDeleteId, setSelectedDeleteId] = useState(null);


const confirmDelete = async () => {
  const id = selectedDeleteId;


    await supabase
        .from("exbition_event_exhibitors")
        .delete()
        .eq("exhibitor_id", id);

    await supabase
        .from("exhibitor_categories")
        .delete()
        .eq("exhibitor_id", id);


await supabase
        .from("exhibitors")
        .delete()
        .eq("id", id);


    setExhibitors((prev) => prev.filter((c) => c.id !== id));
    setShowDeleteModal(false);
    setSelectedDeleteId(null);
};






    return ( 
   <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Exhibitor Management"  
                            para="Manage exhibitors content"
                            />
                            
                          <AddCTA    title='Add Exhibitor'   
                          onClick={() => {
                          
                                    setOpen(true);
                                }}  
                                
                                />
                     
                            {open && (
                                <form className="overlay-create" onSubmit={handleSubmit}>
                                    <fieldset className="container-create">

                                    <div class="header-create">
                                        <h1 className="title-create">
                                     {editingId ? "Edit Exhibitor" : " Add Exhibitor"}
                                        </h1>
                                        <button className="close-btn-create" type="button" 
                                        onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                        <img alt="close" src={pic30}/></button>
                                        </div>

                                         <Input title="Exhibitor Name"
                                         placeholder='Enter exhibitor name'
                                        value={form.exhibitor_name}
                                        onChange={(e) => setForm({ ...form, exhibitor_name: e.target.value })}
                                        />
                                        <Errormsginput message={errors.exhibitor_name} />

                                    <Textarea title="Description" 
                                    placeholder='Enter description'
                                     stylee='main-text-area'
                                            value={form.description}
                                            onChange={(e) => setForm({ ...form, description: e.target.value })} />
                                    <Input title="Logo URL"
                                    placeholder="Enter logo image link"
                                    value={form.logo}
                                    onChange={(e) => setForm({ ...form, logo: e.target.value })} />

                                    <Input title="Booth Number"
                                    placeholder='e.g. Booth A-101'
                                            value={form.booth_number}
                                            onChange={(e) => setForm({ ...form, booth_number: e.target.value })} />


                                        <Input title="Contact Email"
                                        placeholder='Enter email'
                                                value={form.contact_email}
                                                onChange={(e) => setForm({ ...form, contact_email: e.target.value })} />


                                    <Input title="Image URL" 
                                    placeholder="Enter image link"
                                        value={form.image}
                                        onChange={(e) => setForm({ ...form, image: e.target.value })} />

                                              <Input title="Image Alt"
                                         placeholder='Enter image name'
                                        value={form.img_alt}
                                        onChange={(e) => setForm({ ...form, img_alt: e.target.value })} />

                                    <Input title="Hover Image URL"
                                    placeholder="Enter hover image link"
                                        value={form.hover_image}
                                        onChange={(e) => setForm({ ...form, hover_image: e.target.value })} />

                                    <Input title="Hover Image Alt" 
                                    placeholder='Enter hover image name'
                                            value={form.hover_alt}
                                            onChange={(e) => setForm({ ...form, hover_alt: e.target.value })} />


                                        {/* <Selectinput
                                        title="Featured"
                                                value={form.is_featured}
                                                onChange={(e) => setForm({ ...form, is_featured: e.target.value === "true" })}
                                                options={[
                                                { value: "true", label: "Yes" },
                                                { value: "false", label: "No" }
                                                ]} /> */}


                                      <div className='containerr-sub-inputs-category'>
                                    <h3>Associated Events</h3>
                                    {form.events.map((selectedEventtt, index) => (
                                    <div key={index} className="exhibitor-row">


                                        <Selectinput
                                        title={`Event ${index + 1}`}
                                        value={selectedEventtt}
                                        onChange={(e) => updateEvent(e.target.value, index)}
                                        options={[
                                        { value: "", label: "Select event" },...eventOptions.map((e) => ({ value: e.id, label: e.event_name })) ]} />



                                        <button type="button" className="delete-exhibitor-btn"
                                        onClick={() => removeEvent(index)}>✕</button>
                                    </div>))}

                                 
                                    <button
                                    type="button"
                                    className="upload-ctaa"
                                    onClick={addEventSelect}
                                    >
                                    <img src={pic44} alt="add" className="add-icon" />
                                    <h2 className='text-uploadd-cta'>Add Exhibitor</h2>
                                    </button>
                                </div>


                                        <Errormsginput message={errors.events} />


                                    <nav className='container-ctas-craete'>
                                          <Cta
                                           title={editingId ? "Update Exhibitor" : "Create Exhibitor"}
                                            className="cta-create"
                                            type="submit"
                                            />
                                            <button className='cta-cancel-create' onClick={() => {
                                            setOpen(false);
                                                setEditingId(null);
                                            }}>
                                            <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                            </button>
                                    </nav>
                                    </fieldset>
                                </form>
                                )}  

                                
                                  
        </article>


          <section className='container-table-eventp'>




                                        {showDeleteModal  && (
                                                <section className="delete-modal-overlay">
                                                    <article className="delete-modal">

                                                    <header className="delete-modal-header">
                                                        <div className="delete-icon-wrapper">
                                                        <img src={pic31} alt='icon' />
                                                        </div>

                                                        <div className="delete-text-container">
                                                        <h2 className="delete-title">Delete Category</h2>
                                                        <p className="delete-description">
                                                            Are you sure you want to delete this Category?
                                                        </p>
                                                        </div>
                                                    </header>

                                                    <nav className="container-ctas-craete">

                                                       <Cta 
                                                         onClick={confirmDelete}
                                                        title='Delete'
                                                       className="cta-create"
                                                       type="button" />

                                                    <button className='cta-cancel-create' 
                                                    onClick={() => {
                                                        setShowDeleteModal(false);
                                                        setSelectedDeleteId(null);
                                                    }}>
                                                    <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                                    </button>
                                                              
                                                                
                                                    </nav>

                                                    </article>
                                                </section>
                                                )}





                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search Exhibitors..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic26} className="search-icon" alt="search" />
                            </fieldset>

                            <fieldset className='container-inputs-event-p'>
                                    <div className="select-wrapper">
                                                <img src={pic25} className="arrow-icon" alt="arrow" />
                                                <img src={pic24} className="select-icon" alt="filter" />
                                    <select
                                        className="input-search select-style"
                                        value={sort}
                                             onChange={(e) => setSort(e.target.value)} >
                                      <option value="">Sort By</option>
                                    <option value="booth_asc">Booth A → Z</option>
                                    <option value="booth_desc">Booth Z → A</option>
                                        </select>
                                     </div>


                            </fieldset>



                             <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>Exhibitor Name</th>
                                        <th className='table-header-text'>Associated Events</th>
                                        <th className='table-header-text'>Booth Number</th>
                                        <th className='table-header-text'>Description</th>                                                                                                                                                                                                                                       
                                        <th className='table-header-text'>contact_email</th>

                                         <th className='table-header-text'>home_image</th>
                                           <th className='table-header-text'>img_alt</th>
                                          <th className='table-header-text'>hover_image</th>
                                        <th className='table-header-text'>hover_alt</th>
                                        <th className='table-header-text'>Actions</th>

                                    </tr>
                                    </thead>

                               {currentCategories.map((item) => {


                                    return (
                                    <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox"  className='checkboxxx'/>
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='container-event3'>
                                                    <img className='img-tabel-event3' src={item.logo} alt='pic'></img>
                                                   <h2 className='event-title'> {item.exhibitor_name}</h2> 
                                                </td>


                                                <td className='container-event-desc-long'>
                                                    {item.exbition_event_exhibitors?.length > 0 ? (
                                                        <ul className='events-list'>
                                                            {item.exbition_event_exhibitors.map((link, i) => (
                                                                <li key={i}>{link.exbition_event?.event_name}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <span>No events</span>
                                                    )}
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                    {item.booth_number}
                                                </td>

                                                 <td className='container-event-desc'>
                                                    <p className="truncate-text">
                                                   {item.description}
                                                   </p>
                                                </td>


                                                <td className='mainwhite-table-font'>
                                                    {item.contact_email}
                                                </td>
                                            
                                                <figure className='mainwhite-table-font'>
                                                <img className='img-tabel-event' src= {item.image} alt='event-image'/>
                                                </figure>
   
                                                <td className='mainwhite-table-font'>
                                                    {item.img_alt}
                                                </td>
                                                <figure className='mainwhite-table-font'>
                                                <img className='img-tabel-event' src= {item.hover_image} alt='event-image'/>
                                                </figure>

                                                <td className='mainwhite-table-font'>
                                                    {item.hover_alt}
                                                </td>


                                            
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>

                                                            <button
                                                            className='cta2-table'
                                                            
                                                            >
                                                                <img src={pic27} alt='edit' />
                                                            </button>



                                                          <button
                                                        className='cta2-table'
                                                        onClick={async () => {
                                                            setOpen(true);
                                                            setEditingId(item.id);

                                                            const { data: linksData } = await supabase
                                                                .from("exbition_event_exhibitors")
                                                                .select("event_exhibitors_id")
                                                                .eq("exhibitor_id", item.id);

                                                            setForm({
                                                                exhibitor_name: item.exhibitor_name,
                                                                description: item.description,
                                                                booth_number: item.booth_number,
                                                                contact_email: item.contact_email,
                                                                img_alt: item.img_alt,
                                                                  logo: item.logo,  
                                                                image: item.image,
                                                                hover_image: item.hover_image,
                                                                hover_alt: item.hover_alt,
                                                                events: linksData.map((l) => l.event_exhibitors_id)
                                                            });
                                                        }}
                                                    >
                                                        <img src={pic28} alt='edit' />
                                                    </button>
                                                            


                                                            <button
                                                            className='cta2-table'

                                                            
                                                            >
                                                                <img src={pic29} alt='delete' 
                                                                  onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
                                   );
                                        })}
                                </table>
                                </div>

                                       




            </section>

            <nav className="pagination-container">

            <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
            </button>

            <section className="pagination-numbers">
                {[...Array(totalPages)].map((_, index) => (<button
                    key={index}
                    className={
                    currentPage === index + 1
                        ? "pagination-number active-page"
                        : "pagination-number"
                    }
                    onClick={() => setCurrentPage(index + 1)}>
                    {index + 1}</button>
                ))}
            </section>

            <button
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}>
                Next
            </button>

            </nav>


    </section>
     );
}
 
export default Exhibitorscontent;